module.exports = {
  searchBar: {
    placeholder: 'Brand, model, year ...',
  },
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/translations/price_guide/en.js